import React from 'react';
import { Image, useColorModeValue } from '@chakra-ui/react';

/**
 * ロゴコンポーネント
 * GenX AI OCRのロゴを表示
 */
const Logo = ({ width = '200px', height = 'auto', ...props }) => {
  // GenX AI OCRロゴのパス
  const logoPath = '/assets/GenX-AI-OCR-logo.png';
  
  return (
    <Image
      src={logoPath}
      alt="GenX AI OCR Logo"
      width={width}
      height={height}
      objectFit="contain"
      {...props}
    />
  );
};

export default Logo;